import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

// Returns settings grouped by category: { lead_source: [...], followup_status: [...], ... }
export const fetchSettings = async () => {
  const res = await axios.get(`${baseUrl}/settings`);
  return res.data && typeof res.data === 'object' ? res.data : {};
};

export const fetchSettingsByCategory = async (category) => {
  const res = await axios.get(`${baseUrl}/settings`, { params: { category } });
  return Array.isArray(res.data) ? res.data : [];
};

export const createSetting = (values) => axios.post(`${baseUrl}/settings`, values);
export const updateSetting = (id, values) => axios.put(`${baseUrl}/settings/${id}`, values);
export const deleteSetting = (id) => axios.delete(`${baseUrl}/settings/${id}`);
